/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 10/21/2019
 *
 * @version 0.1
 * Revisions:
 * 10/21/2019 - BW - Initial Creation
 *
 * Description/Purpose:
 * Header JS
 ************************************************************** */
import HeaderNavigation from 'layout/header-navigation';
import HeaderNavUser from "layout/header-nav-user";


const Header = {

  init() {
    HeaderNavigation.init();
    HeaderNavUser.init();
  },

};
export default Header;
